module.exports = __webpack_public_path__ + "img/05成都卫健委.3f58a5cb.png";